import { render, staticRenderFns } from "./candidateListTagCell.vue?vue&type=template&id=bc12be24&scoped=true"
import script from "./candidateListTagCell.vue?vue&type=script&lang=js"
export * from "./candidateListTagCell.vue?vue&type=script&lang=js"
import style0 from "./candidateListTagCell.vue?vue&type=style&index=0&id=bc12be24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc12be24",
  null
  
)

export default component.exports